module.exports = __webpack_public_path__ + "img/en-t.3b1be4b5.png";